import React from 'react'
import { useStyles } from './ActiveSubscriptionsChart.styles'
import { useTheme } from '@mui/material/styles'
import { TotalAndPercentage } from '../TotalAndPercentage/TotalAndPercentage'
import { CustomLegends } from '../CustomLegends/CustomLegends'
import { BarChartComponent } from '../../../common/components/BarChartComponent/BarChartComponent'
import { themeForRevenueLineGraph } from '../RevenueOverviewChart/RevenueOverviewChart.styles'
import { useSelector } from '../../../store/hooks'
import { Overview } from '../../../modules/flyoutOverview/types'
import { getGraphDateLabel } from '../../../common/utils/getGraphDateLabel'
import { OverviewEmptyState } from '../OverviewEmptyState/OverviewEmptyState'
import OverviewEmptyStateImage from '../../../common/images/overviewEmptyState.png'

export const ActiveSubscriptionsChart = ({
  dateRangeDescription,
}: {
  dateRangeDescription: string
}) => {
  const { classes } = useStyles()
  const theme = useTheme()
  const lineGraphTheme = themeForRevenueLineGraph(
    theme.palette.labraText.description
  )

  const { activeSubscription } = useSelector<Overview>(
    state => state.flyoutOverview?.overview
  )

  const isActiveSubscriptionDataEmpty =
    !activeSubscription?.data || activeSubscription.data.length === 0

  const activeSubscriptionList = activeSubscription?.data?.map(
    subscriptionItem => ({
      aws: subscriptionItem?.aws,
      gcp: subscriptionItem?.gcp,
      microsoft: subscriptionItem?.microsoft,
      month: getGraphDateLabel(subscriptionItem?.date),
    })
  )

  return (
    <>
      {isActiveSubscriptionDataEmpty ? (
        <OverviewEmptyState
          imgUrl={OverviewEmptyStateImage}
          containerHeight={31.75}
          imageHeight={12}
          imageWidth={16.75}
          description="No active subscription on your product(s) exist right now."
        />
      ) : (
        <div
          data-testid={'active-subscriptions-chart'}
          className={classes.root}
        >
          <TotalAndPercentage
            total={activeSubscription?.total}
            percentage={activeSubscription?.percentage}
            type={activeSubscription?.rise}
            label="in last 1 year"
          />
          <div
            className={classes.legendsWrapper}
            data-testid={'custom-legend-wrapper'}
          >
            <CustomLegends
              legends={[
                {
                  label: 'AWS',
                  legendColor: theme.palette.awsGraph.main,
                  legendSize: 'medium',
                },
                {
                  label: 'Microsoft',
                  legendColor: theme.palette.microsoftGraph.main,
                  legendSize: 'medium',
                },
                {
                  label: 'GCP',
                  legendColor: theme.palette.gcpGraph.main,
                  legendSize: 'medium',
                },
              ]}
            />
          </div>
          <div data-testid={'active-subscriptions-bar-chart'}>
            <BarChartComponent
              classes={classes}
              data={activeSubscriptionList}
              keys={['aws', 'microsoft', 'gcp']}
              indexBy="month"
              theme={lineGraphTheme}
              colors={[
                theme.palette.awsGraph.main,
                theme.palette.microsoftGraph.main,
                theme.palette.gcpGraph.main,
              ]}
              gridYValues={6}
              axisBottomLegend={`(${dateRangeDescription})`}
              showToolTip={true}
              leftTickValues={6}
            />
          </div>
        </div>
      )}
    </>
  )
}
